class MegaMenu extends HTMLElement {
    constructor() {
        super();
        this.timer = null;
        this.items = this.querySelectorAll('.header-menu.mega');
        this.menus = this.querySelectorAll('.header-menu-content > .wrapper');
        this.items.forEach((item) => {
            item.addEventListener('mouseenter', this.menuOpen.bind(this));
            item.addEventListener('mouseleave', this.menuClose.bind(this));
        });
        this.menus.forEach((menu) => {
            menu.addEventListener('mouseenter', this.menuEnter.bind(this));
            menu.addEventListener('mouseleave', this.menuClose.bind(this));
        });
    }

    menuClose(event) {
        return;
        let $self = this;
        this.timer = setTimeout(function(){
            document.querySelector('body').classList.remove('desktop-menu-open');
            $self.items.forEach((item) => {
                item.classList.remove('active');
            })
        }, 400);
    }

    menuEnter(event) {
        clearTimeout(this.timer);
    }

    menuOpen(event) {
        var clickedItem = event.target;
        clearTimeout(this.timer);
        clickedItem.classList.add('active');
        document.querySelector('body').classList.add('desktop-menu-open');
        this.items.forEach((item) => {
            if(item != clickedItem) {
                item.classList.remove('active');
            }
        })
    }
}

customElements.define('mega-menu', MegaMenu);